import React, { useEffect } from 'react';
import NewHero from './NewHero';
import NewPitch from './NewPitch';
import NewProcess from './NewProcess';
import NewAbout from './NewAbout';
import NewValues from './NewValues';
import NewServices from './NewServices';
import NewProjects from './NewProjects';
import NewFaq from './NewFaq';
import NewFooter from './NewFooter';

function NewPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <NewHero />
      <NewPitch />
      <NewProcess />
      <NewAbout />
      <NewValues />
      <NewServices />
      <NewProjects />
      <NewFaq />
      <NewFooter />
    </div>
  );
}

export default NewPage;
